/*
 * File: /src/store/modules/contentBlocks.js
 * Created Date: Tuesday December 14th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:46:13 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import ContentBlockService from 'src/services/contentBlockService';

const state = {
  contentBlocks: undefined,
};

const getters = {
  getBlocks: (state) => state.contentBlocks,
  getTextBlocks: (state) =>
    state.contentBlocks.filter((c) => c.block_type == 'text'),
  getHtmlBlocks: (state) =>
    state.contentBlocks.filter((c) => c.block_type == 'html'),
};
const actions = {
  async fetchBlocks({ commit, state }) {
    // Only load the data once
    if (state.contentBlocks == undefined) {
      // Only load active blocks into the store
      return ContentBlockService.fetchAll({ filter: ['active:eq:true'] }).then(
        (r) => {
          commit('setBlocks', r.data);
        }
      );
    }
  },
  unloadBlocks({ commit }) {
    commit('setBlocks', undefined);
  },
};
const mutations = {
  setBlocks(state, blocks) {
    state.contentBlocks = blocks;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
